import { useNavigate } from 'react-router-dom'
import EditableListPage from '../components/EditableListPage'
import TableView from '../../shared/components/TableView'
import { useTranslation } from 'react-i18next'

const PaymentLog = () => {
    const navigate = useNavigate()
    const { t } = useTranslation()

    const renderTable = items => {
        const columns = [
            { key: 'donation_id', label: t('fields.payment_logs.fields.donation_id') },
            { key: 'event_type', label: t('fields.payment_logs.fields.event_type') },
            { key: 'received_at', label: t('fields.payment_logs.fields.received_at') },
        ]

        const handleRowClick = item => {
            navigate(`/admin/auth/payment-logs/${item.id}`)
        }

        return (
            <TableView
                data={items}
                columns={columns}
                onRowClick={handleRowClick}
                search={false}
                // searchKeys={['name']}
                // searchPlaceholder='Search by name'
            />
        )
    }

    return (
        <EditableListPage
            title={t('navigation_admin.donations.payment_logs')}
            endpoint='admin/payment-logs'
            renderTable={renderTable}
            view='table'
            rowLink='/admin/auth/payment-logs'
        />
    )
}

export default PaymentLog
